import React from 'react'
import ActionBar from '../ActionBar'

export default function Failed(props: {
  data: KnowledgeRetrievalOutput,
  onResend?: (data: KnowledgeRetrievalOutput) => void;
}) {
  return (
    <>
      <div className='chat-block__failed'>{props.data.outputs?.summary || "网络联接失败，无法处理该请求。"}</div>
      <ActionBar actions={["resend"]} data={props.data} onResend={props.onResend}/>
    </>
  )
}
